/* eslint-disable func-names */
import React, { Component } from "react";
import { connect } from "react-redux";
import { getTKT1NetworkModems, createTKT1NetworkModem, updateTKT1NetworkModem } from '../actions';
import ScrollToTop from "react-scroll-to-top";
import Pagination from "../components/Pagination";
import { CONFIGS } from "../configs";
import { getTranslate, LANGUAGE_KEYS } from "../utils";
import queryString from 'query-string';
import {
  Badge,
  Button,
  Card,
  Form,
  Table,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  InputGroup,
  Modal
} from "react-bootstrap";
import { FaTimes, FaEye, FaEdit, FaTrash, FaCopy, FaExternalLinkAlt } from 'react-icons/fa';

class TKT1NetworkModem extends Component {
  initQuery = {
    currentPage: 1,
    itemsPerPage: 100,
    sortBy: 'location_id',
    sortOrder: 1,
    search: '',
    provider: '',
    status: ''
  }

  initShowColumns = {
    SN: true,
    location_id: true,
    location_description: true,
    wifi_name: true,
    provider: true,
    setup_fee: true,
    monthly_fee: true,
    registration_start_date: true,
    expiry_date: true,
    ref_device_pack_location_id: true,
    status: true,
    note: true
  }

  constructor() {
    super();
    this.state = {
      query: this.initQuery,
      showColumns: this.initShowColumns,
      loading: false,
      showConfigModal: false,
      showEditModal: false,
      showViewModal: false,
      showAddModal: false,
      selectedNetworkModem: null,
      isEditMode: false,
      editFormData: {
        SN: '',
        location_id: '',
        location_description: '',
        wifi_name: '',
        provider: '',
        setup_fee: 0,
        monthly_fee: 0,
        registration_start_date: '',
        expiry_date: '',
        ref_device_pack_location_id: '',
        status: 'ACTIVE',
        note: ''
      }
    };
  }

  componentDidMount() {
    document.title = 'TKT1 Network Modem';
    const queryStringFromUrl = window.location.search;
    const urlParams = new URLSearchParams(queryStringFromUrl);
    
    // Check if URL has any query parameters
    const hasUrlParams = queryStringFromUrl && queryStringFromUrl.length > 1;
    
    if (hasUrlParams) {
      // URL has query parameters - override localStorage
      const queryObject = queryString.parse(queryStringFromUrl);
      
      // Parse numeric values
      ['itemsPerPage', 'currentPage'].map(key => {
        if (queryObject[key]) {
          queryObject[key] = parseInt(queryObject[key])
        }
      })
      if (queryObject.sortOrder) {
        queryObject.sortOrder = parseInt(queryObject.sortOrder);
      }
      
      // Load showColumns separately from view config
      const viewConfig = JSON.parse(localStorage.getItem('TKT1NetworkModem_ViewConfig'));
      
      const restoredQuery = {
        ...this.initQuery,
        ...queryObject
      };

      this.setState({
        query: restoredQuery,
        showColumns: {
          ...this.initShowColumns,
          ...(viewConfig || {})
        }
      }, () => {
        const apiQuery = this.prepareApiQuery(this.state.query);
        this.props.getTKT1NetworkModems(apiQuery);
      })
    } else {
      // No URL params - use localStorage
      var query = JSON.parse(localStorage.getItem('tkt1_network_modem_query'));
      var viewConfig = JSON.parse(localStorage.getItem('TKT1NetworkModem_ViewConfig'));
      
      if (query) {
        const restored = {
          ...this.initQuery,
          ...query
        };
        restored.itemsPerPage = parseInt(restored.itemsPerPage || this.initQuery.itemsPerPage);
        restored.currentPage = parseInt(restored.currentPage || this.initQuery.currentPage);
        restored.sortOrder = parseInt(restored.sortOrder || this.initQuery.sortOrder);

        this.setState({
          query: restored,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1NetworkModems(apiQuery);
        })
      } else {
        this.setState({
          query: this.initQuery,
          showColumns: {
            ...this.initShowColumns,
            ...(viewConfig || {})
          }
        }, () => {
          const apiQuery = this.prepareApiQuery(this.state.query);
          this.props.getTKT1NetworkModems(apiQuery);
        })
      }
    }
  }

  loadData = () => {
    const apiQuery = this.prepareApiQuery(this.state.query);
    this.props.getTKT1NetworkModems(apiQuery);
  }

  handleChangeSearch = (e) => {
    this.setState({
      query: { ...this.state.query, search: e.target.value }
    })
  }

  handleClearSearch = () => {
    this.setState({
      query: { ...this.state.query, search: '' }
    }, () => {
      this.handleSearch();
    })
  }

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch();
    }
  }

  handleProviderChange = (e) => {
    const newQuery = { ...this.state.query, provider: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_network_modem_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1NetworkModems(apiQuery);
  }

  handleStatusChange = (e) => {
    const newQuery = { ...this.state.query, status: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_network_modem_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1NetworkModems(apiQuery);
  }

  handleSelectSort = (e) => {
    const newQuery = { ...this.state.query, sortBy: e.target.value };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_network_modem_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1NetworkModems(apiQuery);
  }

  handleSelectSortOrder = (e) => {
    const newQuery = { ...this.state.query, sortOrder: parseInt(e.target.value) };
    this.setState({ query: newQuery });
    localStorage.setItem('tkt1_network_modem_query', JSON.stringify(newQuery));
    
    // Auto search when dropdown changes
    const apiQuery = this.prepareApiQuery(newQuery);
    this.updateUrl(newQuery);
    this.props.getTKT1NetworkModems(apiQuery);
  }

  handleColumnToggle = (columnKey) => {
    this.setState(prevState => {
      const newShowColumns = {
        ...prevState.showColumns,
        [columnKey]: !prevState.showColumns[columnKey]
      };
      
      // Save view config to localStorage
      localStorage.setItem('TKT1NetworkModem_ViewConfig', JSON.stringify(newShowColumns));
      
      return { showColumns: newShowColumns };
    })
  }

  // Map status to Vietnamese
  mapStatus = (status) => {
    if (!status) return '-';
    switch (status.toUpperCase()) {
      case 'ACTIVE':
        return 'Hoạt động';
      case 'INACTIVE':
        return 'Không hoạt động';
      case 'CANCEL':
        return 'Hủy';
      default:
        return status;
    }
  }

  // Map provider to Vietnamese
  mapProvider = (provider) => {
    if (!provider) return '-';
    switch (provider.toUpperCase()) {
      case 'FPT':
        return 'FPT';
      case 'VIETTEL':
        return 'Viettel';
      case 'VNPT':
        return 'VNPT';
      default:
        return provider;
    }
  }

  // Copy text to clipboard
  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      console.log('Copied to clipboard:', text);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  // Modal handlers
  handleViewClick = (networkModem) => {
    this.setState({
      showViewModal: true,
      selectedNetworkModem: networkModem,
      isEditMode: false
    });
  }

  handleEditClick = (networkModem) => {
    this.setState({
      showEditModal: true,
      selectedNetworkModem: networkModem,
      isEditMode: true,
      editFormData: {
        SN: networkModem.SN || '',
        location_id: networkModem.location_id || '',
        location_description: networkModem.location_description || '',
        wifi_name: networkModem.wifi_name || '',
        provider: networkModem.provider || '',
        setup_fee: networkModem.setup_fee || 0,
        monthly_fee: networkModem.monthly_fee || 0,
        registration_start_date: networkModem.registration_start_date ? 
          new Date(networkModem.registration_start_date).toISOString().split('T')[0] : '',
        expiry_date: networkModem.expiry_date ? 
          new Date(networkModem.expiry_date).toISOString().split('T')[0] : '',
        ref_device_pack_location_id: networkModem.ref_device_pack_location_id || '',
        status: networkModem.status || 'ACTIVE',
        note: networkModem.note || ''
      }
    });
  }

  handleCloseViewModal = () => {
    this.setState({
      showViewModal: false,
      selectedNetworkModem: null,
      isEditMode: false
    });
  }

  handleCloseEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedNetworkModem: null,
      isEditMode: false,
      editFormData: {
        SN: '',
        location_id: '',
        location_description: '',
        wifi_name: '',
        provider: '',
        setup_fee: 0,
        monthly_fee: 0,
        registration_start_date: '',
        expiry_date: '',
        ref_device_pack_location_id: '',
        status: 'ACTIVE',
        note: ''
      }
    });
  }

  handleEditInputChange = (field, value) => {
    this.setState({
      editFormData: {
        ...this.state.editFormData,
        [field]: value
      }
    });
  }

  handleSaveEdit = async () => {
    const { selectedNetworkModem, editFormData } = this.state;
    
    if (!selectedNetworkModem || !selectedNetworkModem._id) {
      alert('Không tìm thấy thông tin Network Modem để cập nhật');
      return;
    }

    try {
      // Prepare data for update
      const updateData = {
        ...editFormData,
        setup_fee: editFormData.setup_fee ? parseFloat(editFormData.setup_fee) : 0,
        monthly_fee: editFormData.monthly_fee ? parseFloat(editFormData.monthly_fee) : 0,
        registration_start_date: editFormData.registration_start_date ? new Date(editFormData.registration_start_date).toISOString() : null,
        expiry_date: editFormData.expiry_date ? new Date(editFormData.expiry_date).toISOString() : null
      };

      // Call update action
      await this.props.updateTKT1NetworkModem(selectedNetworkModem._id, updateData);
      
      // Close modal
      this.handleCloseEditModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1NetworkModems(apiQuery);
      
      alert('Cập nhật thông tin Network Modem thành công!');
    } catch (error) {
      console.error('Error updating network modem:', error);
      alert('Lỗi khi cập nhật thông tin Network Modem. Vui lòng thử lại.');
    }
  }

  handleAddClick = () => {
    this.setState({
      showAddModal: true,
      editFormData: {
        SN: '',
        location_id: '',
        location_description: '',
        wifi_name: '',
        provider: '',
        setup_fee: 0,
        monthly_fee: 0,
        registration_start_date: '',
        expiry_date: '',
        ref_device_pack_location_id: '',
        status: 'ACTIVE',
        note: ''
      }
    });
  }

  handleCloseAddModal = () => {
    this.setState({
      showAddModal: false,
      editFormData: {
        SN: '',
        location_id: '',
        location_description: '',
        wifi_name: '',
        provider: '',
        setup_fee: 0,
        monthly_fee: 0,
        registration_start_date: '',
        expiry_date: '',
        ref_device_pack_location_id: '',
        status: 'ACTIVE',
        note: ''
      }
    });
  }

  handleSaveAdd = async () => {
    const { editFormData } = this.state;
    
    // Validate required fields
    if (!editFormData.SN || !editFormData.SN.trim()) {
      alert('Vui lòng nhập Serial Number');
      return;
    }
    if (!editFormData.location_id || !editFormData.location_id.trim()) {
      alert('Vui lòng nhập Location ID');
      return;
    }

    try {
      // Prepare data for create
      const createData = {
        ...editFormData,
        setup_fee: editFormData.setup_fee ? parseFloat(editFormData.setup_fee) : 0,
        monthly_fee: editFormData.monthly_fee ? parseFloat(editFormData.monthly_fee) : 0,
        registration_start_date: editFormData.registration_start_date ? new Date(editFormData.registration_start_date).toISOString() : null,
        expiry_date: editFormData.expiry_date ? new Date(editFormData.expiry_date).toISOString() : null
      };

      // Call create action
      await this.props.createTKT1NetworkModem(createData);
      
      // Close modal
      this.handleCloseAddModal();
      
      // Refresh data
      const apiQuery = this.prepareApiQuery(this.state.query);
      this.props.getTKT1NetworkModems(apiQuery);
      
      alert('Thêm Network Modem mới thành công!');
    } catch (error) {
      console.error('Error creating network modem:', error);
      alert('Lỗi khi thêm Network Modem mới. Vui lòng thử lại.');
    }
  }

  // Helper function to prepare API query
  prepareApiQuery = (query) => {
    const { showColumns, search, provider, status, ...baseQuery } = query;
    const apiQuery = {
      ...baseQuery,
      search: search ? search.trim() : ''
    };
    
    // Add provider filter if selected
    if (provider && provider.trim()) {
      apiQuery.provider = provider;
    }
    
    // Add status filter if selected
    if (status && status.trim()) {
      apiQuery.status = status;
    }
    
    return apiQuery;
  }

  handleChangeItemsPerPage = (e) => {
    const itemsPerPage = parseInt(e.target.value);
    const trimmedQuery = {
      ...this.state.query,
      itemsPerPage,
      currentPage: 1,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    // Save to localStorage
    localStorage.setItem('tkt1_network_modem_query', JSON.stringify(trimmedQuery));
    
    this.setState({
      query: { ...this.state.query, itemsPerPage, currentPage: 1 }
    }, () => {
      this.updateUrl(trimmedQuery);
      this.props.getTKT1NetworkModems(apiQuery);
    })
  }

  handleSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }
    this.handleSearch();
  }

  handleSearch = () => {
    const trimmedQuery = {
      ...this.state.query,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);
    
    this.updateUrl(trimmedQuery);
    this.props.getTKT1NetworkModems(apiQuery);
    localStorage.setItem('tkt1_network_modem_query', JSON.stringify(trimmedQuery));
  }

  updateUrl = (query) => {
    const { history } = this.props;
    // Remove showColumns from URL query - it's only for client display
    const { showColumns, ...urlQuery } = query;
    const queryStr = queryString.stringify(urlQuery);

    history.push({
      pathname: '/admin/tkt1-device/network-modem',
      search: queryStr,
    });
  }

  updatePage = (itemOffset, newPage) => {
    if (newPage == this.state.query.currentPage)
      return;

    const trimmedQuery = {
      ...this.state.query,
      currentPage: newPage,
      search: this.state.query.search.trim()
    };
    
    const apiQuery = this.prepareApiQuery(trimmedQuery);

    this.setState({
      query: { ...this.state.query, currentPage: newPage },
    }, () => {
      this.setState({ networkModems: [] }, () => {
        this.updateUrl(trimmedQuery);
        this.props.getTKT1NetworkModems(apiQuery);
        localStorage.setItem('tkt1_network_modem_query', JSON.stringify(trimmedQuery));
      })
    })
  }

  renderSearchFilter = () => {
    return <>
      <Row className="mb-3">
        <Col md="3">
          <InputGroup className="mb-3">
            <InputGroup.Text>Tìm kiếm</InputGroup.Text>
            <Form.Control
              defaultValue=""
              value={this.state.query.search}
              onChange={this.handleChangeSearch}
              onKeyPress={this.handleKeyPress}
              placeholder="Tìm kiếm theo SN, location..."
              aria-label="search"
              aria-describedby="basic-addon1"
            />
            {this.state.query.search && (
              <InputGroup.Text
                onClick={this.handleClearSearch}
                style={{
                  cursor: 'pointer',
                  backgroundColor: 'transparent',
                  borderLeft: 'none'
                }}
                title="Xóa tìm kiếm"
              >
                <FaTimes size={12} />
              </InputGroup.Text>
            )}
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Nhà cung cấp</InputGroup.Text>
            <Form.Select
              value={this.state.query.provider}
              onChange={this.handleProviderChange}
            >
              <option value="">Tất cả</option>
              <option value="FPT">FPT</option>
              <option value="VIETTEL">Viettel</option>
              <option value="VNPT">VNPT</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Trạng thái</InputGroup.Text>
            <Form.Select
              value={this.state.query.status}
              onChange={this.handleStatusChange}
            >
              <option value="">Tất cả</option>
              <option value="ACTIVE">Hoạt động</option>
              <option value="INACTIVE">Không hoạt động</option>
              <option value="CANCEL">Hủy</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Sắp xếp theo</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortBy}
              onChange={this.handleSelectSort}
            >
              <option value="location_id">Location ID</option>
              <option value="created_at">Ngày tạo</option>
              <option value="updated_at">Ngày cập nhật</option>
              <option value="SN">Serial Number</option>
              <option value="expiry_date">Ngày hết hạn</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="2">
          <InputGroup>
            <InputGroup.Text>Thứ tự</InputGroup.Text>
            <Form.Select
              value={this.state.query.sortOrder}
              onChange={this.handleSelectSortOrder}
            >
              <option value="-1">Giảm dần</option>
              <option value="1">Tăng dần</option>
            </Form.Select>
          </InputGroup>
        </Col>
        <Col md="1" className="d-flex align-items-center justify-content-end">
          <Button
            className="btn-fill btn"
            type="submit"
            variant="primary"
            onClick={this.handleSubmit}
          >
            Tìm kiếm
          </Button>
        </Col>
      </Row>
    </>
  }

  renderNetworkModemTable = () => {
    const { networkModems } = this.props;
    const { showColumns } = this.state;
    
    // Ensure networkModems is an array and filter out any null/undefined items
    const safeNetworkModems = Array.isArray(networkModems) ? networkModems.filter(modem => modem != null && typeof modem === 'object') : [];
    
    // Early return if no data to prevent any rendering issues
    if (!safeNetworkModems || safeNetworkModems.length === 0) {
      return (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={{ width: '60px' }}>STT</th>
              {showColumns.location_id && <th>Location ID</th>}
              {showColumns.SN && <th>Serial Number</th>}
              {showColumns.location_description && <th>Mô tả vị trí</th>}
              {showColumns.wifi_name && <th>Tên WiFi</th>}
              {showColumns.provider && <th>Nhà cung cấp</th>}
              {showColumns.setup_fee && <th>Phí lắp đặt</th>}
              {showColumns.monthly_fee && <th>Phí hàng tháng</th>}
              {showColumns.registration_start_date && <th>Ngày bắt đầu</th>}
              {showColumns.expiry_date && <th>Ngày hết hạn</th>}
              {showColumns.ref_device_pack_location_id && <th>Device Pack Location ID</th>}
              {showColumns.status && <th>Trạng thái</th>}
              {showColumns.note && <th>Ghi chú</th>}
              <th style={{ width: '100px' }}>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={Object.values(showColumns).filter(Boolean).length + 2} className="text-center">
                {this.state.loading ? 'Đang tải...' : 'Không có dữ liệu'}
              </td>
            </tr>
          </tbody>
        </Table>
      );
    }
    
    return (
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th style={{ width: '60px' }}>STT</th>
            {showColumns.location_id && <th>Location ID</th>}
            {showColumns.SN && <th>Serial Number</th>}
            {showColumns.location_description && <th>Mô tả vị trí</th>}
            {showColumns.wifi_name && <th>Tên WiFi</th>}
            {showColumns.provider && <th>Nhà cung cấp</th>}
            {showColumns.setup_fee && <th>Phí lắp đặt</th>}
            {showColumns.monthly_fee && <th>Phí hàng tháng</th>}
            {showColumns.registration_start_date && <th>Ngày bắt đầu</th>}
            {showColumns.expiry_date && <th>Ngày hết hạn</th>}
            {showColumns.ref_device_pack_location_id && <th>Device Pack Location ID</th>}
            {showColumns.status && <th>Trạng thái</th>}
            {showColumns.note && <th>Ghi chú</th>}
            <th style={{ width: '100px' }}>Thao tác</th>
          </tr>
        </thead>
        <tbody>
          {safeNetworkModems.map((modem, index) => {
            if (!modem || typeof modem !== 'object') return null;
              
              return (
                <tr key={modem._id || index}>
                  <td>{(this.state.query.currentPage - 1) * this.state.query.itemsPerPage + index + 1}</td>
                  {showColumns.location_id && (
                    <td>{modem.location_id || '-'}</td>
                  )}
                  {showColumns.SN && (
                    <td>
                      {modem.SN ? (
                        <div className="d-flex align-items-center gap-2">
                          <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>{modem.SN}</Badge>
                          <FaCopy 
                            size={12} 
                            style={{ cursor: 'pointer', color: '#6c757d' }}
                            onClick={() => this.copyToClipboard(modem.SN)}
                            title="Copy Serial Number"
                          />
                        </div>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.location_description && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={modem.location_description}>
                        {modem.location_description || '-'}
                      </div>
                    </td>
                  )}
                  {showColumns.wifi_name && (
                    <td>{modem.wifi_name || '-'}</td>
                  )}
                  {showColumns.provider && (
                    <td>
                      {modem.provider ? (
                        <Badge 
                          bg={
                            modem.provider === 'FPT' ? 'primary' :
                            modem.provider === 'VIETTEL' ? 'success' :
                            modem.provider === 'VNPT' ? 'warning' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapProvider(modem.provider)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.setup_fee && (
                    <td>
                      {modem.setup_fee ? (
                        <span className="text-success fw-bold">
                          {modem.setup_fee.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.monthly_fee && (
                    <td>
                      {modem.monthly_fee ? (
                        <span className="text-primary fw-bold">
                          {modem.monthly_fee.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.registration_start_date && (
                    <td>
                      {modem.registration_start_date ? 
                        new Date(modem.registration_start_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </td>
                  )}
                  {showColumns.expiry_date && (
                    <td>
                      {modem.expiry_date ? 
                        new Date(modem.expiry_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </td>
                  )}
                  {showColumns.ref_device_pack_location_id && (
                    <td>
                      {modem.ref_device_pack_location_id ? (
                        <Badge 
                          bg="info" 
                          style={{ 
                            fontSize: '0.9em',
                            padding: '6px 10px'
                          }}
                        >
                          {modem.ref_device_pack_location_id}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.status && (
                    <td>
                      {modem.status ? (
                        <Badge 
                          bg={
                            modem.status === 'ACTIVE' ? 'success' :
                            modem.status === 'INACTIVE' ? 'warning' :
                            modem.status === 'CANCEL' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(modem.status)}
                        </Badge>
                      ) : '-'}
                    </td>
                  )}
                  {showColumns.note && (
                    <td>
                      <div style={{ whiteSpace: 'nowrap' }} 
                           title={modem.note}>
                        {modem.note || '-'}
                      </div>
                    </td>
                  )}
                  <td>
                    <div className="d-flex align-items-center gap-2">
                      <FaEye 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Xem thông tin"
                        onClick={() => this.handleViewClick(modem)}
                      />
                      <FaEdit 
                        size={16} 
                        style={{ 
                          cursor: 'pointer', 
                          color: '#6c757d'
                        }}
                        title="Chỉnh sửa"
                        onClick={() => this.handleEditClick(modem)}
                      />
                    </div>
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <>
        <Container fluid>
          <Row className="mb-4">
            <Col>
              <h2 className="text-primary">
                TKT1 Network Modem
              </h2>
            </Col>
            <Col className="text-end" md="auto">
              <Button
                variant="success"
                size="sm"
                onClick={this.handleAddClick}
                title="Thêm Network Modem mới"
              >
                <i className="fas fa-plus me-1"></i>
                Thêm mới
              </Button>
            </Col>
          </Row>
          {this.renderSearchFilter()}
          <Row>
            <Col>
              <h5 className="d-inline-block">
                <b>Tìm thấy <span className='text-danger'>{this.props.totalCount}</span> bản ghi:</b>
              </h5>
            </Col>
            <Col className="text-end text-nowrap" md="auto">
              <div className="d-inline-flex align-items-center flex-nowrap">
                <Button 
                  variant="secondary" 
                  size="sm"
                  className="me-2"
                  onClick={() => this.setState({ showConfigModal: true })}
                >
                  <i className="fas fa-cog"></i> Cấu hình hiển thị
                </Button>
                <div className="d-inline-block ms-3">
                  <span className="me-2">Số bản ghi/trang:</span>
                  <Form.Select
                    size="sm"
                    value={this.state.query.itemsPerPage}
                    onChange={this.handleChangeItemsPerPage}
                    style={{ width: '100px', display: 'inline-block' }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={200}>200</option>
                  </Form.Select>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {this.renderNetworkModemTable()}
            </Col>
          </Row>
        </Container>
        <Pagination 
          totalItems={this.props.totalCount} 
          itemsPerPage={this.state.query.itemsPerPage} 
          itemOffset={(this.state.query.currentPage - 1) * this.state.query.itemsPerPage} 
          updatePage={this.updatePage} 
        />

        {/* Configuration Modal */}
        <Modal show={this.state.showConfigModal} onHide={() => this.setState({ showConfigModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Cấu hình hiển thị</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <div className="mb-3">
                <h6>Hiển thị cột</h6>
                {Object.entries(this.state.showColumns || {}).map(([column, isVisible]) => {
                  const columnLabels = {
                    SN: 'Serial Number',
                    location_id: 'Location ID',
                    location_description: 'Mô tả vị trí',
                    wifi_name: 'Tên WiFi',
                    provider: 'Nhà cung cấp',
                    setup_fee: 'Phí lắp đặt',
                    monthly_fee: 'Phí hàng tháng',
                    registration_start_date: 'Ngày bắt đầu',
                    expiry_date: 'Ngày hết hạn',
                    ref_device_pack_location_id: 'Device Pack Location ID',
                    status: 'Trạng thái',
                    note: 'Ghi chú'
                  };
                  
                  return (
                    <Form.Check
                      key={column}
                      type="switch"
                      id={`column-${column}`}
                      label={columnLabels[column] || column}
                      checked={isVisible}
                      onChange={() => this.handleColumnToggle(column)}
                      className="mb-2"
                    />
                  );
                })}
              </div>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showConfigModal: false })}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* View Modal */}
        <Modal show={this.state.showViewModal} onHide={this.handleCloseViewModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thông tin Network Modem</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.selectedNetworkModem && (
              <div>
                {/* Basic Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin cơ bản</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Serial Number:</strong> 
                    <div className="mt-1">
                      <Badge bg="info" style={{ fontSize: '0.9em', padding: '6px 10px' }}>
                        {this.state.selectedNetworkModem.SN}
                      </Badge>
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Location ID:</strong> 
                    <div className="mt-1">{this.state.selectedNetworkModem.location_id || '-'}</div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Mô tả vị trí:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedNetworkModem.location_description || '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Network Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin mạng</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Tên WiFi:</strong> 
                    <div className="mt-1">{this.state.selectedNetworkModem.wifi_name || '-'}</div>
                  </Col>
                  <Col md="6">
                    <strong>Nhà cung cấp:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNetworkModem.provider ? (
                        <Badge 
                          bg={
                            this.state.selectedNetworkModem.provider === 'FPT' ? 'primary' :
                            this.state.selectedNetworkModem.provider === 'VIETTEL' ? 'success' :
                            this.state.selectedNetworkModem.provider === 'VNPT' ? 'warning' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapProvider(this.state.selectedNetworkModem.provider)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Financial Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin tài chính</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Phí lắp đặt:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNetworkModem.setup_fee ? (
                        <span className="text-success fw-bold">
                          {this.state.selectedNetworkModem.setup_fee.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Phí hàng tháng:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNetworkModem.monthly_fee ? (
                        <span className="text-primary fw-bold">
                          {this.state.selectedNetworkModem.monthly_fee.toLocaleString('vi-VN')} VNĐ
                        </span>
                      ) : '-'}
                    </div>
                  </Col>
                </Row>
                
                {/* Date Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Thông tin ngày tháng</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Ngày bắt đầu:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNetworkModem.registration_start_date ? 
                        new Date(this.state.selectedNetworkModem.registration_start_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Ngày hết hạn:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNetworkModem.expiry_date ? 
                        new Date(this.state.selectedNetworkModem.expiry_date).toLocaleDateString('vi-VN') : 
                        '-'
                      }
                    </div>
                  </Col>
                </Row>
                
                {/* Status Information */}
                <Row className="mb-4">
                  <Col>
                    <h5 className="text-primary">Trạng thái</h5>
                    <hr />
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col md="6">
                    <strong>Trạng thái:</strong> 
                    <div className="mt-1">
                      {this.state.selectedNetworkModem.status ? (
                        <Badge 
                          bg={
                            this.state.selectedNetworkModem.status === 'ACTIVE' ? 'success' :
                            this.state.selectedNetworkModem.status === 'INACTIVE' ? 'warning' :
                            this.state.selectedNetworkModem.status === 'CANCEL' ? 'danger' :
                            'secondary'
                          }
                          style={{ fontSize: '0.8em', padding: '4px 8px' }}
                        >
                          {this.mapStatus(this.state.selectedNetworkModem.status)}
                        </Badge>
                      ) : '-'}
                    </div>
                  </Col>
                  <Col md="6">
                    <strong>Device Pack ID:</strong> 
                    <div className="mt-1">{this.state.selectedNetworkModem.ref_device_pack_location_id || '-'}</div>
                  </Col>
                </Row>
                
                {/* Additional Information */}
                <Row className="mb-3">
                  <Col md="12">
                    <strong>Ghi chú:</strong> 
                    <div className="mt-1" style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.selectedNetworkModem.note || '-'}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseViewModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Modal */}
        <Modal show={this.state.showEditModal} onHide={this.handleCloseEditModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Chỉnh sửa Network Modem</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Serial Number</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.SN}
                      onChange={(e) => this.handleEditInputChange('SN', e.target.value)}
                      placeholder="Nhập Serial Number"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Location ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.location_id}
                      onChange={(e) => this.handleEditInputChange('location_id', e.target.value)}
                      placeholder="Nhập Location ID"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Nhà cung cấp</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.provider}
                      onChange={(e) => this.handleEditInputChange('provider', e.target.value)}
                    >
                      <option value="">Chọn nhà cung cấp</option>
                      <option value="FPT">FPT</option>
                      <option value="VIETTEL">Viettel</option>
                      <option value="VNPT">VNPT</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="CANCEL">Hủy</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Mô tả vị trí</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.location_description}
                      onChange={(e) => this.handleEditInputChange('location_description', e.target.value)}
                      placeholder="Nhập mô tả vị trí"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên WiFi</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.wifi_name}
                      onChange={(e) => this.handleEditInputChange('wifi_name', e.target.value)}
                      placeholder="Nhập tên WiFi"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="CANCEL">Hủy</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Phí lắp đặt (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.setup_fee}
                      onChange={(e) => this.handleEditInputChange('setup_fee', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập phí lắp đặt"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Phí hàng tháng (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.monthly_fee}
                      onChange={(e) => this.handleEditInputChange('monthly_fee', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập phí hàng tháng"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày bắt đầu</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.registration_start_date}
                      onChange={(e) => this.handleEditInputChange('registration_start_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày hết hạn</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.expiry_date}
                      onChange={(e) => this.handleEditInputChange('expiry_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Device Pack Location ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_device_pack_location_id}
                      onChange={(e) => this.handleEditInputChange('ref_device_pack_location_id', e.target.value)}
                      placeholder="Nhập Device Pack Location ID"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleEditInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseEditModal}>
              Hủy
            </Button>
            <Button variant="primary" onClick={this.handleSaveEdit}>
              Lưu thay đổi
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add Modal */}
        <Modal show={this.state.showAddModal} onHide={this.handleCloseAddModal} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Thêm Network Modem mới</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Serial Number <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.SN}
                      onChange={(e) => this.handleEditInputChange('SN', e.target.value)}
                      placeholder="Nhập Serial Number"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Location ID <span className="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.location_id}
                      onChange={(e) => this.handleEditInputChange('location_id', e.target.value)}
                      placeholder="Nhập Location ID"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Nhà cung cấp</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.provider}
                      onChange={(e) => this.handleEditInputChange('provider', e.target.value)}
                    >
                      <option value="">Chọn nhà cung cấp</option>
                      <option value="FPT">FPT</option>
                      <option value="VIETTEL">Viettel</option>
                      <option value="VNPT">VNPT</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="CANCEL">Hủy</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Mô tả vị trí</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.location_description}
                      onChange={(e) => this.handleEditInputChange('location_description', e.target.value)}
                      placeholder="Nhập mô tả vị trí"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Tên WiFi</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.wifi_name}
                      onChange={(e) => this.handleEditInputChange('wifi_name', e.target.value)}
                      placeholder="Nhập tên WiFi"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Trạng thái</Form.Label>
                    <Form.Select
                      value={this.state.editFormData.status}
                      onChange={(e) => this.handleEditInputChange('status', e.target.value)}
                    >
                      <option value="ACTIVE">Hoạt động</option>
                      <option value="INACTIVE">Không hoạt động</option>
                      <option value="CANCEL">Hủy</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Phí lắp đặt (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.setup_fee}
                      onChange={(e) => this.handleEditInputChange('setup_fee', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập phí lắp đặt"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Phí hàng tháng (VNĐ)</Form.Label>
                    <Form.Control
                      type="number"
                      value={this.state.editFormData.monthly_fee}
                      onChange={(e) => this.handleEditInputChange('monthly_fee', parseFloat(e.target.value) || 0)}
                      placeholder="Nhập phí hàng tháng"
                      min="0"
                      step="1000"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày bắt đầu</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.registration_start_date}
                      onChange={(e) => this.handleEditInputChange('registration_start_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Ngày hết hạn</Form.Label>
                    <Form.Control
                      type="date"
                      value={this.state.editFormData.expiry_date}
                      onChange={(e) => this.handleEditInputChange('expiry_date', e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="6">
                  <Form.Group>
                    <Form.Label>Device Pack Location ID</Form.Label>
                    <Form.Control
                      type="text"
                      value={this.state.editFormData.ref_device_pack_location_id}
                      onChange={(e) => this.handleEditInputChange('ref_device_pack_location_id', e.target.value)}
                      placeholder="Nhập Device Pack Location ID"
                    />
                  </Form.Group>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Ghi chú</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.editFormData.note}
                      onChange={(e) => this.handleEditInputChange('note', e.target.value)}
                      placeholder="Nhập ghi chú"
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleCloseAddModal}>
              Hủy
            </Button>
            <Button variant="success" onClick={this.handleSaveAdd}>
              Thêm mới
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    networkModems: state.tkt1NetworkModemReducer.networkModems,
    totalCount: state.tkt1NetworkModemReducer.totalCount
  };
};

export default connect(mapStateToProps, { getTKT1NetworkModems, createTKT1NetworkModem, updateTKT1NetworkModem })(TKT1NetworkModem);
